import React from 'react'
import { PixelAlert, PixelCurrency, colors } from 'pixel-base'
import styled from 'styled-components'
const tenant_info: any = JSON.parse(localStorage.getItem('tenant_info') || '{}')
const OrdersCard = (props) => {
  const {
    mainDec,
    variant,
    title,
    totalCount,
    isCOD,
    COD = '',
    CODDec,
    countINCurrency,
  } = props
  const alertStyle = {
    border: '1px solid #e0e0e0',
    borderRadius: '5px',
    padding: '10px',
    width: '24%',
    margin: '0px',
    minHeight: '90px',
  }
  return (
    <PixelAlert style={alertStyle} variant={variant}>
      <StatsItemTitle>{title}</StatsItemTitle>
      <StatsItemContainer justify={!isCOD}>
        {isCOD && (
          <StatsItemsOrders>
            <span
              style={{
                fontSize: '16px',
              }}
            >
              {COD == '' ? (
                '--'
              ) : (
                <>
                  <span
                    style={{
                      fontSize: '10px',
                    }}
                  >
                    {tenant_info?.default_currency_symbol}
                  </span>
                  <PixelCurrency hideSymbol={true} value={COD} />
                </>
              )}
            </span>
            <StatsItemCount
              justify={false}
              style={{
                marginBottom: '2px',
                fontSize: '10px',
              }}
            >
              {CODDec || 0}
            </StatsItemCount>
          </StatsItemsOrders>
        )}

        <StatsItems className={isCOD ? '' : 'rowWise'}>
          <OrdersCount>
            {' '}
            {countINCurrency ? (
              <PixelCurrency value={totalCount} />
            ) : (
              <>{totalCount || 0}</>
            )}
          </OrdersCount>
          <StatsItemCount>{mainDec}</StatsItemCount>
        </StatsItems>
      </StatsItemContainer>
    </PixelAlert>
  )
}

const StatsItemTitle = styled.div`
  font-size: 14px;
  width: 100%;
  padding-bottom: 5px;
  font-weight: bold;
  color: #000;
  margin: 0px;
`
const StatsItemCount = styled.div<{ justify?: boolean }>`
  font-size: 10px;
  font-weight: 300;
  color: #000;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.justify ? 'space-between' : 'flex-end')};
  padding-bottom: ${(props) => (props.justify ? '0px' : '8px')};
  align-items: center;
  align-content: center;
`
const StatsItemContainer = styled.div<{ justify?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.justify ? 'flex-start' : 'flex-end')};
  gap: 5px;
`
const OrdersCount = styled.div`
  font-size: 30px;
  font-weight: 500;
`
const StatsItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  align-items: center;
  width: 30%;
  &.rowWise {
    width: 100%;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
  }
`
const StatsItemsOrders = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: flex-start;
  align-items: flex-start;
  width: 70%;
`

const OrderAlertCardContainer = styled.div`
  border: 1px solid ${colors.grayBorderLight};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: ${colors.white};
`

const OrderAlertCardTitle = styled.h3`
  color: ${colors.black};
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
`

const OrderAlertCardDescription = styled.p`
  color: ${colors.black};
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`

export default OrdersCard
